import { trackTaskNotificationClickedEvent } from '@/lib/analytics/scribe/task';
import { useCallback, useMemo } from 'react';

type TaskNotificationType = 'assigned' | 'due_soon' | 'overdue';

/**
 * Provides a handler for task_notification_clicked analytics.
 * Only fires when notificationType is resolved (i.e. a known task notification).
 */
export function useTaskNotificationTracking(
  isTaskNotification: boolean,
  taskId: string | undefined,
  notificationType: TaskNotificationType | undefined
) {
  const trackClicked = useCallback(() => {
    if (!isTaskNotification || !notificationType) return;
    trackTaskNotificationClickedEvent({
      task_id: taskId,
      notification_type: notificationType,
    });
  }, [isTaskNotification, taskId, notificationType]);

  return useMemo(() => ({ trackClicked }), [trackClicked]);
}
